import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'

import { UpdateMachinePageHeader } from '@/components/pages/Machines/Update'
import UpdateMachineForm, { UpdateMachineFormValue } from '@/components/pages/Machines/Update/Form'
import { useTanks } from '@/pages/Tank/Tank.hooks'
import { Machine } from '@/types'

import { useMachines } from '../Machine.hooks'
import { useGetMachine, useUpdateMachines } from './update.hooks'

const UpdateMachine = () => {
  const params = useParams<{ id: string }>()
  const { updateMachine, loading: updateLoading } = useUpdateMachines()

  const { getMachine, loading: getLoading, response: getMachineResponse } = useGetMachine()
  const { deleteMachine } = useMachines()
  const { getAllTanks, tanks } = useTanks()

  const machineId = Number(params.id)

  const handleDeleteMachine = async (id: Machine['id']) => {
    await deleteMachine({ id })
  }

  const handleSubmitForm = async (formValues: UpdateMachineFormValue) => {
    await updateMachine({
      ...formValues,
      id: machineId,
    })
  }

  useEffect(() => {
    getMachine({ id: machineId })
    getAllTanks()
  }, [machineId, getMachine, params.id, getAllTanks])

  return (
    <>
      <UpdateMachinePageHeader />
      <UpdateMachineForm
        {...{ updateLoading, getLoading, getMachineResponse, machineId, tanks }}
        onSubmit={handleSubmitForm}
        onDelete={handleDeleteMachine}
      />
    </>
  )
}

UpdateMachine.displayName = 'UpdateMachine'
export default UpdateMachine
